import { modalStoreLenses } from 'root/src/client/logic/modal/lenses'

const { viewModalProps } = modalStoreLenses

export default routeId => (dispatch, getState) => viewModalProps(routeId, getState())
